export const MAIN_ROUTE = "/";
export const PROJECTS_ROUTE = "/projects";
export const REVIEWS_ROUTE = "/reviews";
export const ABOUT_ROUTE = "/about";
export const STAGES_ROUTE = "/stages";
export const CONTACTS_ROUTE = "/contacts";
export const FILLEDFORM_ROUTE = "/form";
